<template>
  <Teleport to="#modals">
    <Modal v-if="route.name === 'ChangePassword'" @close="handleRouteClose">
      <template #header-all>
        <BackButton :click="handleRouteClose" type="button"></BackButton>
        <h2>
          {{ title }}
        </h2>
      </template>
      <template #content>
        <ChangePasswordForm
          @success="handleSuccess"
          :label-old-password="
            route.query.temporaryPassword
              ? 'Временный пароль'
              : 'Текущий пароль'
          "
        />
      </template>
    </Modal>
    <Modal v-else @close="() => emit('close')">
      <template #header-all>
        <BackButton :click="() => emit('close')" type="button">
          Отмена
        </BackButton>
      </template>
      <template #content>
        <ChangePasswordForm @success="handleSuccess" />
      </template>
    </Modal>
  </Teleport>
</template>

<script setup>
import Modal from '@/components/Modal.vue'
import ChangePasswordForm from '@/components/ChangePasswordForm.vue'
import { useStore } from 'vuex'
import BackButton from '@/components/BackButton.vue'
import useAuth from '@/utils/useAuth'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const emit = defineEmits(['close'])

const route = useRoute()
const router = useRouter()
const store = useStore()
const { logout } = useAuth()

const isRequiredPasswordChange = computed(
  () =>
    route.query.temporaryPassword === true ||
    route.query.temporaryPassword === 'true'
)

const title = computed(() =>
  isRequiredPasswordChange.value
    ? 'Необходимо установить постоянный пароль'
    : 'Необходимо установить новый пароль'
)

const handleRouteClose = async () => {
  if (isRequiredPasswordChange.value) {
    await logout()
    return
  }

  await router.replace({ name: 'Home' })
}

const handleSuccess = async () => {
  await logout({ redirect: false })

  store.dispatch('showSuccess', {
    text: 'Ваш пароль успешно изменен',
    btnText: 'Войти в сервис',
    onClick: () => window.location.replace('/auth'),
  })
}
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  padding: 0 20px;
}
</style>
